import { toast } from "react-toastify";
import firebase from "firebase/compat/app";
import { StorageService } from "../services/StorageService";
import { StorageValues } from "../constants/storageValues";

export const Stringutility = {
  isNullOrEmpty,
  getValue,
  showErrorMessage,
  showSuccessMessage
};

function isNullOrEmpty(value) {
  if (
    value == null ||
    value === "" ||
    value === undefined ||
    value === "undefined"
  ) {
    return true;
  } else {
    return false;
  }
}

function getValue(data) {
  var value = "";
  if (!isNullOrEmpty(data)) {
    value = data;
  }
  return value;
}

function showErrorMessage(message) {
  toast.error(message);
}

function showSuccessMessage(message) {
  toast.success(message);
}

